import React from 'react';
import { Table } from 'semantic-ui-react';
import { columnName, columnDescription } from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';

const UsersGroupsTableColumns = ({ allowRemove }) => (
  <Table.Row className="aridhia-users-groups-table-columns">
    <UnsortedColumn columnId={columnName} />
    <UnsortedColumn columnId={columnDescription} />
    {allowRemove && (<UnsortedColumn />)}
  </Table.Row>
);

export default UsersGroupsTableColumns;
